<template>
  <div class="introduction-stock-page">
    <introduction-tab :activeKey="activeKey"></introduction-tab>
    <router-view></router-view>
  </div>
</template>
<script>
import IntroductionTab from '@/components/IntroductionTab/index.vue'
import { useRoute, onBeforeRouteUpdate } from 'vue-router'
import { onMounted , ref } from '@vue/runtime-core'
export default {
  name:'introduction-stock-page',
  components:{
    IntroductionTab
  },
  setup(){
    let route = useRoute()
    let activeKey = ref('')
    onMounted(()=>{
      console.log('onMounted',route.name)

      let name = route.name || ''
      if(name){
        activeKey.value = name
      }
    })
    onBeforeRouteUpdate((to, from, next)=>{
      console.log('onBeforeRouteUpdate')
      next()
      console.log(to)
      let name = to.name || ''
      if(name){
        activeKey.value = name
      }
    })
    return {
      activeKey
    }
  }
}
</script>
<style lang="stylus">
.introduction-stock-page
  width 100%
  height 100%
  overflow hidden
  position relative
  padding-top 80px
  box-sizing border-box
</style>